export default __webpack_public_path__ + "static/media/GuideStar.8b6d551e.png";